import script from "./DoubaoPaper.vue?vue&type=script&setup=true&lang=js"
export * from "./DoubaoPaper.vue?vue&type=script&setup=true&lang=js"

import "./DoubaoPaper.vue?vue&type=style&index=0&id=06bf0558&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06bf0558"]])

export default __exports__